export const BANKID = "BankID";
export const COMPLETE = "complete";
export const EXPIRED_TRANSACTION = "expiredTransaction";
export const FAILED = "failed";
export const OUTSTANDING_TRANSACTION = "outstandingTransaction";
export const PENDING = "pending";
export const START_FAILED = "startFailed";
export const UNKNOWN = "unknown";
export const USER_SIGN = "userSign";
